// import { axiosInstance, interceptorSetup } from "../axiosSetup";
import { axiosInstance, interceptorSetup } from "../axiosSetup2";

// Wrapper around axiosInstance methods
const api = {
    async get(url, config) {
      await interceptorSetup; // Ensure interceptors are set up
      return axiosInstance.get(url, config);
    },
    async post(url, data, config) {
      await interceptorSetup; // Ensure interceptors are set up
      return axiosInstance.post(url, data, config);
    },
    async put(url, data, config) {
      await interceptorSetup; // Ensure interceptors are set up
      return axiosInstance.put(url, data, config);
    },
    async delete(url, config) {
      await interceptorSetup; // Ensure interceptors are set up
      return axiosInstance.delete(url, config);
    },
    // Add other axios methods if needed (patch, head, etc.)
  };

export default api;